import { QUERY_KEYS } from 'api/query-keys';
import { flexPoolService } from 'ogp/services';
import { useMutation, useQueryClient } from 'react-query';

type DeleteFlexWorkerFromFlexPoolData = { flexPoolId: string; flexWorkerId: string };

export const useDeleteFlexWorkerFromFlexPool = () => {
  const queryClient = useQueryClient();
  const mutationFn = async (data: DeleteFlexWorkerFromFlexPoolData) =>
    await flexPoolService.removeFlexWorkersFromFlexPool(data.flexPoolId, [data.flexWorkerId]);

  return useMutation(mutationFn, {
    onSettled: async () => {
      await queryClient.invalidateQueries(QUERY_KEYS.flexPools());
      await queryClient.invalidateQueries(QUERY_KEYS.workers());
    },
  });
};
